import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { img, listingPath } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { PopularBadge } from "@/components/site/PopularBadge";

export const ListingCard = ({ listing, large }) => {
  const rent = listing.kind === "rent";
  const { t, L, to } = useLang();
  const href = to(listingPath(listing));
  return (
    <article className="card-lift group flex h-full flex-col overflow-hidden rounded-2xl border border-clay bg-white" data-testid={`listing-card-${listing.slug}`}>
      <Link to={href} className={`img-zoom relative block overflow-hidden ${large ? "aspect-[16/10]" : "aspect-[4/3]"}`} data-testid={`listing-card-image-${listing.slug}`}>
        <img src={img(listing.cover_image)} alt={`${L(listing, "title")} — Escamequita, Nicaragua`} loading="lazy" className="h-full w-full object-cover" />
        <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-forest backdrop-blur">
          {rent ? listing.price_tier || t("card.stay") : listing.category === "land" ? t("card.land") : listing.category === "ranch" ? t("card.ranch") : t("card.home")}
        </span>
        <PopularBadge slug={listing.slug} className="absolute right-4 top-4" />
      </Link>
      <div className="flex flex-1 flex-col p-6 sm:p-7">
        {!rent && <p className="font-display text-2xl font-black text-forest" data-testid={`listing-card-price-${listing.slug}`}>{L(listing, "price_label")}</p>}
        <h3 className="mt-1 font-display text-xl font-bold leading-snug text-ink sm:text-2xl">
          <Link to={href} className="hover:text-forest">{L(listing, "title")}</Link>
        </h3>
        {listing.location && (
          <p className="mt-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-sage"><MapPin className="h-3.5 w-3.5" />{L(listing, "location")}</p>
        )}
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-moss">{L(listing, "tagline")}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {L(listing, "specs").slice(0, 3).map((s) => (
            <span key={s} className="rounded-full bg-linen px-3 py-1 text-xs font-bold text-ink/80">{s}</span>
          ))}
        </div>
        <div className="mt-auto flex flex-wrap items-center gap-3 pt-6">
          <Link to={href} className="btn-outline !px-5 !py-2" data-testid={`listing-card-details-${listing.slug}`}>{t("card.details")}</Link>
          {rent && listing.external_url && (
            <a href={listing.external_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-bold text-forest hover:underline" data-testid={`listing-card-book-${listing.slug}`}>
              {L(listing, "cta_label") || t("card.avail")} <ArrowUpRight className="h-4 w-4" />
            </a>
          )}
        </div>
      </div>
    </article>
  );
};
